import { render } from "./CookiesColorPicker.vue?vue&type=template&id=156b1dfb&scoped=true"
import script from "./CookiesColorPicker.vue?vue&type=script&lang=js"
export * from "./CookiesColorPicker.vue?vue&type=script&lang=js"

import "./CookiesColorPicker.vue?vue&type=style&index=0&id=156b1dfb&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-156b1dfb"]])

export default __exports__